import { render } from "./StripeBindingsCard.vue?vue&type=template&id=024a97df&scoped=true"
import script from "./StripeBindingsCard.vue?vue&type=script&lang=js"
export * from "./StripeBindingsCard.vue?vue&type=script&lang=js"

import "./StripeBindingsCard.vue?vue&type=style&index=0&id=024a97df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024a97df"]])

export default __exports__